import { post, get } from '../axios'

// 查询三方登录配置
export function querythirdParty(map) {
  return get(`${process.env.VUE_APP_BMW}/thirdParty/query`, map)
}
// 更新三方登录配置
export function updatethirdParty(map) {
  return post(`${process.env.VUE_APP_BMW}/thirdParty/update`, map)
}
